import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.5 11.5H2.167m12 2.333H3.5M8.833 2.5v1.333M3.5 9.167H2.167m2.876-3.79L4.1 4.432m8.524.943.943-.943M15.5 9.167h-1.333m-8.667 0a3.333 3.333 0 0 1 6.667 0"
    }, null, -1)
  ])))
}
export default { render: render }